export default __webpack_public_path__ + "static/angels-and-demons-ed2a4f7d65e0ab1cd5d8c430026df9f2.webp";